import React from "react";
import CourseForm from "../components/courseForm/CourseForm";

const CourseRegistrationPage = () => {
  return <CourseForm />;
};

export default CourseRegistrationPage;
